module.exports = __webpack_public_path__ + "img/icon-letter-t.e80d18b5.svg";